import { AuditorForm } from './components';
import {
  BasicInfoSupplier,
  ActivityAreaForm,
  BankForm,
  DocumentsEquipmentSupplier,
  DocumentsSupplier,
  TermsSupplier,
  UpdateDocumentsEquipmentSupplier,
  } from '../mainFormForeignSupplier/components';
import { tabs } from '../mainFormForeignSupplier/components/basicInfoSupplier/tabs';
  // import { getLocalString, localNames } from "utils/localisation.service";
import { isEmpty, isNil } from 'lodash';

export const stepsAuditor = ({ activeTaskName, auditorComment, objCommentBen, objectionCommitteeComment }) =>  {
  return [
 {
    name: 'BASICFORMSUPPLIER',
    label: 'Βασικά Στοιχεία Προμηθευτή',
    Component: BasicInfoSupplier,
    tabsComponent : tabs(),
    subtabs: true,
    id: 0,
  },
  {
    name: 'AREAFORM',
    label: 'Περιοχή Δραστηριότητας',
    Component: ActivityAreaForm,
    id: 1,
  },
  {
    name: 'EQUIPMENTDOCUMENT',
    label: 'Εξοπλισμός',
    Component: DocumentsEquipmentSupplier,
    id: 2,
  },
  {
    name: 'DOCUMENTS',
    label: 'Έγγραφα',
    Component: DocumentsSupplier,
    id: 3,
  },
  {
    name: 'TERMS',
    label: 'Όροι και Προϋποθέσεις',
    Component: TermsSupplier,
    id: 4,
  },
  {
    name: 'EVALUATIONFORM',
    label: 'Αξιολόγηση Αίτησης',
    Component: AuditorForm,
    id: 5,
  },
   {
    name: 'UPDATEEQUIPMENTDOCUMENT',
    label: 'Ανανέωση Εξοπλισμού',
    Component: UpdateDocumentsEquipmentSupplier,
    id: 6,
    hidden: !(activeTaskName === "task.name.accepted"),
  },
].filter(item => !item?.hidden)
};